import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { BaseComponent } from './base.component';
import { AbstractControl } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'app-inline-validation',
  templateUrl: './inline-validation.component.html',
  styleUrls: ['./inline-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslateDirective],
})
export class InlineValidationComponent extends BaseComponent {
  readonly field = input<string>();
  readonly control = input<AbstractControl>();

  getMessage(): string {
    const messages = this.validationMessages();
    const field = this.field();
    const errors = this.control()?.errors;
    const fieldMessages = field && messages ? messages[field] : undefined;
    if (fieldMessages && errors) {
      const validationKey = Object.keys(errors).find(
        (key) => fieldMessages[key]
      );
      if (validationKey) {
        return fieldMessages[validationKey];
      }
    }
    return '';
  }

  getMessageParams(): Record<string, any> {
    const params = this.validationParams();
    const field = this.field();
    const errors = this.control()?.errors;
    const fieldParams = field && params ? params[field] : undefined;
    if (fieldParams && errors) {
      const validationKey = Object.keys(errors).find((key) => fieldParams[key]);
      if (validationKey) {
        return fieldParams[validationKey];
      }
    }
    return {};
  }
}
